import { GlobalErrorHandler } from './global-error-handler.service';
import { AuthService } from "./auth.service";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID, ErrorHandler } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AngularFirestore } from "@angular/fire/firestore";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { AngularFireModule } from "@angular/fire";
import { environment } from "../environments/environment";
import { LoginComponent } from "./login/login.component";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MAT_MOMENT_DATE_FORMATS } from "@angular/material-moment-adapter";

import { AgmCoreModule } from '@agm/core';

import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MainToolbarComponent } from "./main-toolbar/main-toolbar.component";
import { LayoutModule } from "@angular/cdk/layout";
import { FlexLayoutModule } from "@angular/flex-layout";
import { LogoutComponent } from "./logout/logout.component";
import { LoginFormComponent } from "./login-form/login-form.component";
import { TaProfileFormComponent } from "./ta-profile-form/ta-profile-form.component";
import { ItineraryListComponent } from "./itinerary-list/itinerary-list.component";
import { ItineraryListItemComponent } from "./itinerary-list-item/itinerary-list-item.component";
import { ItineraryStatusLabelPipe } from "./itinerary-status-label.pipe";
import { ItineraryStatusColorPipe } from "./itinerary-status-color.pipe";
import { ItineraryComponent } from "./itinerary/itinerary.component";
import { ItineraryInfoComponent } from "./itinerary-info/itinerary-info.component";
import { ItineraryReservationsComponent } from "./itinerary-reservations/itinerary-reservations.component";
import { ItineraryDayComponent } from "./itinerary-day/itinerary-day.component";
import { ItineraryExpensesComponent } from "./itinerary-expenses/itinerary-expenses.component";
import { ItineraryCustomerRequestsComponent } from "./itinerary-customer-requests/itinerary-customer-requests.component";
import { ItineraryReservationsFlightsComponent } from "./itinerary-reservations-flights/itinerary-reservations-flights.component";
import { ItineraryReservationsAccomodationsComponent } from "./itinerary-reservations-accomodations/itinerary-reservations-accomodations.component";
import { ItineraryReservationsCarsComponent } from "./itinerary-reservations-cars/itinerary-reservations-cars.component";
import { ItineraryReservationsTrainsComponent } from "./itinerary-reservations-trains/itinerary-reservations-trains.component";
import { ItineraryReservationsFerriesComponent } from "./itinerary-reservations-ferries/itinerary-reservations-ferries.component";
import { ItineraryReservationsAccomodationFormComponent } from "./itinerary-reservations-accomodation-form/itinerary-reservations-accomodation-form.component";
import { EmptyListMessageComponent } from "./empty-list-message/empty-list-message.component";
import { StarRatingComponent } from "./star-rating/star-rating.component";
import { ItineraryDayInfoFormComponent } from "./itinerary-day-info-form/itinerary-day-info-form.component";
import { ItineraryDayActivityFormComponent } from "./itinerary-day-activity-form/itinerary-day-activity-form.component";
import { ItineraryReservationsCarFormComponent } from "./itinerary-reservations-car-form/itinerary-reservations-car-form.component";
import { ItineraryExpensesCardComponent } from "./itinerary-expenses-card/itinerary-expenses-card.component";
import { DaysBetweenPipe } from "./days-between.pipe";

import { registerLocaleData, DatePipe } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { ItineraryImageFormFieldComponent } from './itinerary-image-form-field/itinerary-image-form-field.component';
import { ItineraryReservationsTransportationFormComponent } from './itinerary-reservations-transportation-form/itinerary-reservations-transportation-form.component';
import { ItineraryReservationsBusesComponent } from './itinerary-reservations-buses/itinerary-reservations-buses.component';
import { ItineraryReservationsTransportationFormTitleComponent } from './itinerary-reservations-transportation-form-title/itinerary-reservations-transportation-form-title.component';
import { ItineraryReservationsCarFormTitleComponent } from './itinerary-reservations-car-form-title/itinerary-reservations-car-form-title.component';
import { ItineraryReservationsAccomodationFormTitleComponent } from './itinerary-reservations-accomodation-form-title/itinerary-reservations-accomodation-form-title.component';
import { ItineraryDayInfoComponent } from './itinerary-day-info/itinerary-day-info.component';
import { ItineraryDayActivitiesComponent } from './itinerary-day-activities/itinerary-day-activities.component';
import { ItineraryDayPoisComponent } from './itinerary-day-pois/itinerary-day-pois.component';
import { ItineraryDayPoiFormComponent } from './itinerary-day-poi-form/itinerary-day-poi-form.component';
import { TypeformResponseRendererComponent } from './typeform-response-renderer/typeform-response-renderer.component';
import { ItineraryCustomerRequestsCartComponent } from './itinerary-customer-requests-cart/itinerary-customer-requests-cart.component';
import { ItineraryCustomerRequestsTypeformComponent } from './itinerary-customer-requests-typeform/itinerary-customer-requests-typeform.component';
import { ItineraryPreviewComponent } from './itinerary-preview/itinerary-preview.component';
import { LatLngPickerDialogComponent } from './lat-lng-picker-dialog/lat-lng-picker-dialog.component';
import { LatLngInputComponent } from './lat-lng-input/lat-lng-input.component';
import { CouponsComponent } from './coupons/coupons.component';
import { CouponDialogComponent } from './coupon-dialog/coupon-dialog.component';
import { CouponFormComponent } from './coupon-form/coupon-form.component';
import { UserListComponent } from './user-list/user-list.component';
import { HomeComponent } from './home/home.component';
import { UserDetailComponent } from './user-detail/user-detail.component';

import { FirestoreTimestampMomentDateAdapter } from './firestore-timestamp-moment-date-adapter';
import { ImageFormFieldComponent } from './image-form-field/image-form-field.component';
import { UserProfileImageFormFieldComponent } from './user-profile-image-form-field/user-profile-image-form-field.component';
import { ItinerarySortByStatusPipe } from './itinerary-sort-by-status.pipe';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { CustomerHomeComponent } from './customer-home/customer-home.component';
import { CustomerItineraryComponent } from './customer-itinerary/customer-itinerary.component';
import { CustomerItineraryMarkerComponent } from './customer-itinerary-marker/customer-itinerary-marker.component';
import { LinkRouterComponent } from './link-router/link-router.component';
import { ItinerarySettingsComponent } from './itinerary-settings/itinerary-settings.component';
import { ItinerarySnapshotsComponent } from './itinerary-snapshots/itinerary-snapshots.component';
import { InlineHelpButtonComponent } from './inline-help-button/inline-help-button.component';
import { HelpDialogComponent } from './help-dialog/help-dialog.component';
import { CartsComponent } from './carts/carts.component';
import { CartDialogComponent } from './cart-dialog/cart-dialog.component';
import { CartDataRendererComponent } from './cart-data-renderer/cart-data-renderer.component';
import { FooterLegalComponent } from './footer-legal/footer-legal.component';
import { ItineraryCheckupDialogComponent } from './itinerary-checkup-dialog/itinerary-checkup-dialog.component';
import { ItineraryCheckupComponent } from './itinerary-checkup/itinerary-checkup.component';
import { ItineraryReviewCheckupDialogComponent } from './itinerary-review-checkup-dialog/itinerary-review-checkup-dialog.component';
import { ItineraryReviewComponent } from './itinerary-review/itinerary-review.component';
import { ItinerarySettingsGeneralComponent } from './itinerary-settings-general/itinerary-settings-general.component';
import { ItinerarySettingsAssignmentComponent } from './itinerary-settings-assignment/itinerary-settings-assignment.component';
import { AssignmentProposalListItemComponent } from './assignment-proposal-list-item/assignment-proposal-list-item.component';
import { AssignmentProposalAnswerDialogComponent } from './assignment-proposal-answer-dialog/assignment-proposal-answer-dialog.component';
import { REGION } from '@angular/fire/functions';
import { UserDetailProfileComponent } from './user-detail-profile/user-detail-profile.component';
import { UserDetailAssignmentProposalsComponent } from './user-detail-assignment-proposals/user-detail-assignment-proposals.component';
import { ItineraryCustomerRequestsInfoComponent } from './itinerary-customer-requests-info/itinerary-customer-requests-info.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardNavigatorComponent } from './dashboard-navigator/dashboard-navigator.component';
import { UserDetailDestinationsComponent } from './user-detail-destinations/user-detail-destinations.component';
import { UserDetailDestinationsRegionsComponent } from './user-detail-destinations-regions/user-detail-destinations-regions.component';
import { UserDetailDestinationsNationsComponent } from './user-detail-destinations-nations/user-detail-destinations-nations.component';
import { ItinerarySettingsAssignmentProposalsDialogComponent } from './itinerary-settings-assignment-proposals-dialog/itinerary-settings-assignment-proposals-dialog.component';
import { RearrangeDaysDialogComponent } from './rearrange-days-dialog/rearrange-days-dialog.component';

registerLocaleData(localeIt);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MainToolbarComponent,
    LogoutComponent,
    LoginFormComponent,
    TaProfileFormComponent,
    ItineraryListComponent,
    ItineraryListItemComponent,
    ItineraryStatusLabelPipe,
    ItineraryStatusColorPipe,
    ItineraryComponent,
    ItineraryInfoComponent,
    ItineraryReservationsComponent,
    ItineraryDayComponent,
    ItineraryExpensesComponent,
    ItineraryCustomerRequestsComponent,
    ItineraryReservationsFlightsComponent,
    ItineraryReservationsAccomodationsComponent,
    ItineraryReservationsCarsComponent,
    ItineraryReservationsTrainsComponent,
    ItineraryReservationsFerriesComponent,
    ItineraryReservationsAccomodationFormComponent,
    EmptyListMessageComponent,
    StarRatingComponent,
    ItineraryDayInfoFormComponent,
    ItineraryDayActivityFormComponent,
    ItineraryReservationsCarFormComponent,
    ItineraryExpensesCardComponent,
    DaysBetweenPipe,
    ItineraryImageFormFieldComponent,
    ItineraryReservationsTransportationFormComponent,
    ItineraryReservationsBusesComponent,
    ItineraryReservationsTransportationFormTitleComponent,
    ItineraryReservationsCarFormTitleComponent,
    ItineraryReservationsAccomodationFormTitleComponent,
    ItineraryDayInfoComponent,
    ItineraryDayActivitiesComponent,
    ItineraryDayPoisComponent,
    ItineraryDayPoiFormComponent,
    TypeformResponseRendererComponent,
    ItineraryCustomerRequestsCartComponent,
    ItineraryCustomerRequestsTypeformComponent,
    ItineraryPreviewComponent,
    LatLngPickerDialogComponent,
    LatLngInputComponent,
    CouponsComponent,
    CouponDialogComponent,
    CouponFormComponent,
    UserListComponent,
    HomeComponent,
    UserDetailComponent,
    ImageFormFieldComponent,
    UserProfileImageFormFieldComponent,
    ItinerarySortByStatusPipe,
    ErrorDialogComponent,
    CustomerHomeComponent,
    CustomerItineraryComponent,
    CustomerItineraryMarkerComponent,
    LinkRouterComponent,
    ItinerarySettingsComponent,
    ItinerarySnapshotsComponent,
    InlineHelpButtonComponent,
    HelpDialogComponent,
    CartsComponent,
    CartDialogComponent,
    CartDataRendererComponent,
    FooterLegalComponent,
    ItineraryCheckupDialogComponent,
    ItineraryCheckupComponent,
    ItineraryReviewCheckupDialogComponent,
    ItineraryReviewComponent,
    ItinerarySettingsGeneralComponent,
    ItinerarySettingsAssignmentComponent,
    AssignmentProposalListItemComponent,
    AssignmentProposalAnswerDialogComponent,
    UserDetailProfileComponent,
    UserDetailAssignmentProposalsComponent,
    ItineraryCustomerRequestsInfoComponent,
    DashboardComponent,
    DashboardNavigatorComponent,
    UserDetailDestinationsComponent,
    UserDetailDestinationsRegionsComponent,
    UserDetailDestinationsNationsComponent,
    ItinerarySettingsAssignmentProposalsDialogComponent,
    RearrangeDaysDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatListModule,
    MatDividerModule,
    MatChipsModule,
    MatSidenavModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatGridListModule,
    MatSelectModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    LayoutModule,
    FlexLayoutModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsApiKey,
      libraries: ["places"]
    })
  ],
  providers: [
    AngularFirestore,
    AuthService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: LOCALE_ID,
      useValue: 'it'
    },
    DatePipe, {
      provide: DateAdapter,
      useClass: FirestoreTimestampMomentDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MAT_MOMENT_DATE_FORMATS
    },
    {
      provide: REGION,
      useValue: environment.firebase.region
    },
    DaysBetweenPipe
  ],
  bootstrap: [AppComponent],
  entryComponents: [LatLngPickerDialogComponent, CouponDialogComponent, ErrorDialogComponent, HelpDialogComponent, CartDialogComponent, ItineraryCheckupDialogComponent, ItineraryReviewCheckupDialogComponent, AssignmentProposalAnswerDialogComponent]
})
export class AppModule { }
